<template>
  <master-crud-page
    master="sensor_category"
    title="Sensor Category"
    access="master_sensor_category"
    pk="mscaId"
    :columns="columns"
    :fields="fields"
    :filters="filters"
  />
</template>

<script>
import MasterCrudPage from '@/components/master/MasterCrudPage';
import { formatDateTime } from '@/util/date';
import { DISPLAY_DATE } from '@/util/apiDatetime';

const SENSOR_TYPE_SOURCE = {
  master: 'sensor_type',
  keyField: 'mstyId',
  displayField: 'mstyName',
};

export default {
  name: 'MasterSensorCategory',
  components: { MasterCrudPage },
  data() {
    return {
      columns: [
        { key: 'mscaName', label: 'Sensor Category Name', align: 'left' },
        { key: 'mscaMsty.mstyName', label: 'Sensor Category Type', align: 'left' },
        { key: 'mscaCreatedUserId', label: 'Created By', align: 'center' },
        {
          key: 'mscaCreatedTime',
          label: 'Created',
          align: 'center',
          formatter: (value) => formatDateTime(value, DISPLAY_DATE),
        },
      ],
      fields: [
        {
          key: 'mscaName',
          label: 'Sensor Category Name',
          type: 'text',
          required: true,
        },
        {
          key: 'mscaMstyId',
          label: 'Sensor Category Type',
          type: 'select',
          required: true,
          source: SENSOR_TYPE_SOURCE,
        },
      ],
      filters: [
        {
          key: 'mscaMstyId',
          label: 'Sensor Category Type',
          type: 'select',
          source: SENSOR_TYPE_SOURCE,
          colMd: 4,
        },
      ],
    };
  },
};
</script>
